import { createApp } from 'vue'
import ProgramEntryForm from '@/program_entry_form'

document.addEventListener('DOMContentLoaded', () => {
  createApp({ components: { ProgramEntryForm } }).mount('.entry')
})
